export const RESERVE_LEVEL_SELECT_CHANGE_SELECTED_LEVEL = 'reserve_level_select/CHANGE_SELECTED_LEVEL'

export function changeSelectedLevel(selectedLevel) {
    return {
        type: RESERVE_LEVEL_SELECT_CHANGE_SELECTED_LEVEL,
        payload: { selectedLevel },
    }
}



// WEBPACK FOOTER //
// ./state/actions/reserve_level_select.js